import React from 'react'
import { useParams } from 'react-router-dom';
import { DescriptionTargetInfo, ItemCardTargetInfo, LogoImageForCardInfo, MainTargetInfo, SubTitleTargetInfo } from '../../../../../components/card/MainTargetInfo';
import { formatDateWithTime } from '../../../../../utils/dateFormat';
import Money from '../../../../../assets/money.webp';
import { useSelector } from 'react-redux';
import { badgeStaticFormatCssStyle } from '../../../../../utils/styleFormat';

const CardInfo = ({ data, setData }) => {
    const params = useParams()
    const reloadMainTable = useSelector(state => state.login.reloadMainTable)
    return (
        <MainTargetInfo
            extraClassName='grid-cols-1 lg:grid-cols-2 gap-1'
            urlApi={`/compra/${params.compra_id}/detail`}
            setData={setData}
            dataRef={[params.compra_id, reloadMainTable]}
        >
            <ItemCardTargetInfo
                // logoLabel={<LogoLabelTargetInfo logo={<NoteIconSvg />} />}
                logo={<LogoImageForCardInfo logo={Money} />}
                aditionalClassName='col-span-1'
            >
                <div className='flex flex-col sm:flex-row gap-2'>
                    <SubTitleTargetInfo label='' data={'DETALLES DE LA COMPRA'} />
                    <div className='flex'>
                        {
                            data?.concluido ?
                                <div className={`flex gap-1 items-center font-semibold text-xs mr-2 px-2 py-0.5 rounded-full`} style={badgeStaticFormatCssStyle('Concluido')}><span>Concluido</span></div>
                                :
                                <div className={`flex gap-1 items-center font-semibold text-xs mr-2 px-2 py-0.5 rounded-full`} style={badgeStaticFormatCssStyle('Pendiente')}><span>Pendiente</span></div>
                        }
                    </div>
                </div>
                <DescriptionTargetInfo label='Estado:' data={data?.nombre_paso} />
                <DescriptionTargetInfo label='Solicitud:' data={formatDateWithTime(data?.fecha_solicitud)} />
                <DescriptionTargetInfo label='Monto Bs.:' data={data?.monto} />
            </ItemCardTargetInfo>
            <ItemCardTargetInfo
                aditionalClassName='col-span-1'
            >
                <DescriptionTargetInfo label='Comprador:' data={data?.comprador} />
                <DescriptionTargetInfo label='Proveedor:' data={data?.proveedor} />
                <DescriptionTargetInfo label='Transportista:' data={data?.transportista} />
            </ItemCardTargetInfo>
        </MainTargetInfo>
    )
}

export default CardInfo